'use client';

import { Skeleton, SkeletonProps } from '@mui/material';

interface ButtonSkeletonProps extends SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: string | number;
}

export const ButtonSkeleton = ({
  width = 80,
  height = 36,
  borderRadius = '8px',
  sx,
  ...props
}: ButtonSkeletonProps) => {
  return (
    <Skeleton
      variant="rectangular"
      width={width}
      height={height}
      sx={{
        borderRadius,
        ...sx,
      }}
      {...props}
    />
  );
};
